import React from 'react'
import { SEO } from 'newComponents'
import { SimpleImg } from 'react-simple-img'
import Layout from '../components/layout'
import SdkSetupInstructions from '../components/sdkSetupInstructions'
import ClosingCTAs from '../components/ClosingCTAs'

import cardScreen from '../images/implementation/create-a-ff_cardandscreen.svg'
import quick from '../images/implementation/quick-implementation.svg'
import tenX from '../images/case-studies/ten-x-logo-white.png'
import quotes from '../images/implementation/Quotes_v2_Blue.svg'
import handshake from '../images/pricing/Handshake@2x.png'
import auditLog from '../images/implementation/audit_log_details.svg'
import scott from '../images/case-studies/Scott_Ringwelski.png'

const Implementation = () => (
  <Layout>
    <SEO
      title="Implementation"
      description="It's easy to create and test a feature flag in your local dev environment. Our quick start guide shows how to get stared with the our feature management platform. See how your team can use LaunchDarkly within your stack."
    />
    <section className="section is-large  bg-gradient-reverse">
      <div className="container content hero">
        <div className="columns is-desktop">
          <div className="column is-half-desktop">
            <h1 className="title">Getting Your Team Started with Feature Management</h1>
            <p className="text-large">
              We understand the challenges of managing feature flags at scale, so we've built a platform that will help
              you get there. LaunchDarkly is developer-friendly and easy to integrate. Use our quick start guide to
              create a simple app in the language of your choice, and easily create and test a flag in your local dev
              environment.
            </p>
          </div>
          <div className="column is-half-desktop has-text-right">
            <img src={cardScreen} alt="" />
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large">
      <div className="container content">
        <div className="columns">
          <div className="column">
            <p className="text-bold">Quick Setup Time</p>
            <p>
              In just minutes you can set up and start to manage your first feature flag. Teams at organizations like
              GoPro and Atlassian have used LaunchDarkly to deliver code weeks faster and safely test in production.
            </p>
            <p className="text-bold">Partial Implementation</p>
            <p>
              Outcome driven development with feature flags is not all or nothing. Many of our customers start by using
              our feature management platform within in a single team before expanding to other teams/apps across their
              organizations.
            </p>
          </div>
          <div className="column is-half has-text-centered-tablet">
            <img src={quick} style={{ width: '26rem' }} alt="Set up a feature flag in minutes" />
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-dark">
      <div className="container content">
        <div className="columns is-centered is-multiline">
          <div className="column is-12 has-text-centered-tablet">
            <img className="blockquote-logo" src={tenX} alt="Ten-X logo" />
          </div>
          <div className="column is-1-desktop is-1-tablet is-12-mobile">
            <img className="icon righted" src={quotes} alt="quotes" />
          </div>
          <div className="column is-7-desktop is-8-tablet is-12-mobile">
            <h2 className="title">
              LaunchDarkly has been easy to on-board and integrate into our existing development cycle, which has helped
              us move faster with less risk.
            </h2>
            <svg className="stroke-10">
              <line x1="0" y1="0" x2="100%" y2="0" />
            </svg>
            <p className="text-large">Lawrence Yuan, VP Engineering, Ten-X</p>
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-gradient">
      <div className="container content">
        <div className="section-title">
          <h2 className="title">Implement LaunchDarkly in Minutes</h2>
          <p className="subtitle">See what a feature flag looks like in your stack.</p>
        </div>
        <div className="columns">
          <div className="column">
            <SdkSetupInstructions />
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-dark">
      <div className="container content">
        <div className="columns is-centered is-multiline">
          <div className="column is-12 has-text-centered-tablet">
            <img className="blockquote-logo" src={handshake} alt="Handshake logo" />
          </div>
          <div className="column is-1-desktop is-1-tablet is-12-mobile">
            <img className="icon righted" src={quotes} alt="quotes" />
          </div>
          <div className="column is-7-desktop is-8-tablet is-12-mobile">
            <h2 className="title quote">
              When we added LaunchDarkly to our stack, feature toggles quickly became easy and delightful to use. It's
              fundamentally changed the way we build, rollout and test features.
            </h2>
            <svg className="stroke-10">
              <line x1="0" y1="0" x2="100%" y2="0" />
            </svg>
            <div className="homepage-quote">
              <SimpleImg src={scott} alt="Scott Ringwelski" height={80} placeholder="rgba(255,0,0,0.0)" />
              <div>
                <h4 className="quote-text quote-author-name">Scott Ringwelski</h4>
                <p className="quote-text">Co-founder and CTO, Handshake</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section is-large bg-gradient">
      <div className="container content">
        <div className="section-title">
          <h2 className="title">Scalable to Benefit Your Team</h2>
          <p className="subtitle">Scale to your team, scale to your users.</p>
        </div>
        <div className="columns">
          <div className="column">
            <img src={auditLog} alt="audit Log" style={{ width: '33.5rem', height: '22.5rem' }} />
          </div>
          <div className="column">
            <p className="text-box">
              Starting to feature flag is easy, managing them is hard. Managing multiple features across different
              environments is no easy feat—especially when you want to keep everyone in sync and compliant.
            </p>
            <p>
              LaunchDarkly's feature management platform is built for teams. Organize work spaces with projects and
              environments. Support security requirements with team controls, including custom roles and multi-factor
              authentication. Get real time visibility into the full lifecycle of features with an audit log. And an
              intuitive dashboard that is easy for anyone in your organization to use.
            </p>
            <p>
              Our feature management platform is also built for scale. Companies like Atlassian and Microsoft use
              LaunchDarkly to manage features in multiple products across their organizations. We serve over 200 billion
              features daily.
            </p>
          </div>
        </div>
      </div>
    </section>
    <ClosingCTAs title="Ready to Get Your Hands on the Platform?" />
  </Layout>
)

export default Implementation
